import React from 'react';
import { faGear } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const GearIcon = () => (
  <Icon tooltip="Settings" iconObj={faGear} />
);

export default GearIcon;